import React, { useLayoutEffect } from 'react'
import PropTypes from 'prop-types'

import ScrollBar from '@aytm/lib/rfd-ui/components/basic/scroll-bar'

import ButtonSelector from '../ButtonSelector'

import './TableFooter.scss'

import { setCSSVar } from '@aytm/app/insights/dashboard/lib/css'

const CLASS = 'insights-portal-table-footer'

const TableFooter = props => {
  const className = props.className || CLASS

  const style = props.blockWidth ? { width: `${props.blockWidth}px` } : null

  useLayoutEffect(() => {
    setCSSVar('js-table-footer-button-selector-flex', `0 0 ${props.captionWidth - props.leftMargin}px`)
    setCSSVar('js-table-attribute-column-listbox-width', `${props.captionWidth - props.leftMargin}px`)
  }, [props.captionWidth, props.leftMargin])

  return (
    <div className={className} style={style}>
      <ButtonSelector className={`${className}-add visibility-hidden`} disabled onChange={null}>
        <div className={`${className}-add-label`}>
          {/* <i className={`icon-aytmfd-add-question`} /> */}
          {/* <div>Add a row</div> */}
          <div></div>
          <div></div>
          <div></div>
        </div>
      </ButtonSelector>
      <ScrollBar
        ref={props.scrollControlRef}
        className={`${className}-scroll-bar`}
        direction={'horizontal'}
        listenerRef={props.listenerRef}
        elementRef={props.scrollElementRef}
        scrollPosition={props.scrollLeft}
        margins={{ left: props.fixedColumnsWidth, top: -props.dataChartHeight, bottom: -props.bottomScrollMargin }}
        wheelEvents={'bar shift element'}
        ignoreClasses={'p-listbox'}
        onScroll={props.onScroll}
      />
    </div>
  )
}

TableFooter.propTypes = {
  className: PropTypes.string,
  listenerRef: PropTypes.object,
  scrollElementRef: PropTypes.object,
  scrollControlRef: PropTypes.object,
  scrollLeft: PropTypes.number,
  fixedColumnsWidth: PropTypes.number,
  dataChartHeight: PropTypes.number,
  blockWidth: PropTypes.number,
  bottomScrollMargin: PropTypes.number,
  leftMargin: PropTypes.number,
  captionWidth: PropTypes.number,
  onAttributeAdd: PropTypes.func,
  onScroll: PropTypes.func
}

TableFooter.defaultProps = {
  fixedColumnsWidth: 0,
  dataChartHeight: 0,
  scrollLeft: 0,
  bottomScrollMargin: 126,
  leftMargin: 28,
  captionWidth: 220
}

export default TableFooter
